import $ from 'jquery';

var horsePeople = {
    _runFacebookScript: function() {
        (function(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.5';
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    },
    _init: function() {
        var $hero = $('.hero'),
            $sidebar = $('.key');

        if ($hero.length) {
            $sidebar.hide();
        } 

        this._runFacebookScript();
    }
};

export default horsePeople;